import { PersonalizedLettersFilter } from 'assets/js/pages/engage/types';
import { Editor } from 'tinymce';
import { Contact } from 'types/domain';
import { createWithEqualityFn as create } from 'zustand/traditional';

interface PersonalizedLettersStore {
    hasDiffFromMasterLetter: boolean;
    setHasDiffFromMasterLetter: (value: boolean) => void;
    currentPersonalizedLetterContact?: Contact;
    setCurrentPersonalizedLetterContact: (contact?: Contact) => void;
    nextPersonalizedLetterContact?: Contact;
    setNextPersonalizedLetterContact: (contact?: Contact) => void;
    personalizedLettersContactTab: PersonalizedLettersFilter;
    setPersonalizedLettersContactTab: (tab: PersonalizedLettersFilter) => void;
    editorInstance?: Editor;
    setEditorInstance: (editor: Editor) => void;
    isUnsavedChangesDialogOpen: boolean;
    setIsUnsavedChangesDialogOpen: (isUnsavedChangesDialogOpen: boolean) => void;
    personalizedLetterSearch: string;
    setPersonalizedLetterSearch: (personalizedLetterSearch: string) => void;
}

const usePersonalizedLettersStore = create<PersonalizedLettersStore>(set => ({
    setCurrentPersonalizedLetterContact: contact =>
        set({ currentPersonalizedLetterContact: contact }),
    setEditorInstance: editor => set({ editorInstance: editor }),
    hasDiffFromMasterLetter: false,
    setHasDiffFromMasterLetter: hasDiffFromMasterLetter => set({ hasDiffFromMasterLetter }),
    personalizedLettersContactTab: 'all',
    setPersonalizedLettersContactTab: personalizedLettersContactTab =>
        set({
            personalizedLettersContactTab,
        }),
    isUnsavedChangesDialogOpen: false,
    setIsUnsavedChangesDialogOpen: isUnsavedChangesDialogOpen =>
        set({ isUnsavedChangesDialogOpen }),
    setNextPersonalizedLetterContact: contact => set({ nextPersonalizedLetterContact: contact }),
    personalizedLetterSearch: '',
    setPersonalizedLetterSearch: personalizedLetterSearch =>
        set({
            personalizedLetterSearch,
        }),
}));

export { usePersonalizedLettersStore };
